"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryPage = exports.HistoryItem = exports.NotificationList = exports.Notification = exports.NotificationDeletePayload = exports.NotificationUpdatePayload = exports.NotificationCreatePayload = exports.TriggerEvent = exports.TriggerType = exports.Scope = exports.ChannelUpsertResult = exports.ChannelDeletePayload = exports.SmsChannelUpdatePayload = exports.SmsChannelCreatePayload = exports.EmailChannelUpdatePayload = exports.EmailChannelCreatePayload = exports.MobileChannelUpdatePayload = exports.MobileChannelCreatePayload = exports.ChannelList = exports.Channel = exports.ChannelType = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const openapi_1 = require("../../../openapi");
const field_1 = require("../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Notification.Schema';
const optionalDateTime = (description) => effect_1.Schema.optionalWith((0, field_1.dateTime)(description), { exact: true }).annotations({ description });
const email = (description) => effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)).annotations({
    description,
    jsonSchema: { type: 'string', format: 'email' },
});
const optionalUri = (description) => effect_1.Schema.optionalWith(effect_1.Schema.String.annotations({
    description,
    jsonSchema: { type: 'string', format: 'uri' },
}), { exact: true }).annotations({ description });
exports.ChannelType = effect_1.Schema.Literal('push_mobile', 'email', 'sms', 'webhook', 'webhook_svix').annotations({
    identifier: `${exports.NAMESPACE}.ChannelType`,
});
const channelCommon = {
    channelId: (0, field_1.nonEmpty)('Notification channel id (stored id projected by list)'),
    userId: (0, field_1.nonEmpty)('Owner user id'),
    active: effect_1.Schema.Boolean,
    name: (0, field_1.optionalNullableString)('Display name'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
};
const MobileChannel = effect_1.Schema.Struct({
    ...channelCommon,
    type: effect_1.Schema.Literal('push_mobile'),
    token: effect_1.Schema.String,
    platform: effect_1.Schema.Literal('ios', 'android'),
    tokenType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('message', 'pass'), { exact: true }),
    deliveryMethod: effect_1.Schema.optionalWith(effect_1.Schema.Literal('fcm'), { exact: true }),
    permKey: (0, field_1.optionalNullableString)('Apple APN permission key'),
});
const EmailChannel = effect_1.Schema.Struct({
    ...channelCommon,
    type: effect_1.Schema.Literal('email'),
    email: email('Recipient email'),
});
const SmsChannel = effect_1.Schema.Struct({
    ...channelCommon,
    type: effect_1.Schema.Literal('sms'),
    number: effect_1.Schema.String,
});
/**
 * Admin list strips appId and maps stored id to channelId. Webhook channel
 * variants can also be present even though this router cannot create them.
 */
const OtherChannel = effect_1.Schema.Struct({
    ...channelCommon,
    type: effect_1.Schema.Literal('webhook', 'webhook_svix'),
}).pipe(effect_1.Schema.extend(effect_1.Schema.Record({
    key: effect_1.Schema.String,
    value: Json.Value,
})));
exports.Channel = effect_1.Schema.Union(MobileChannel, EmailChannel, SmsChannel, OtherChannel).annotations({
    identifier: `${exports.NAMESPACE}.Channel`,
    description: 'Notification channel returned by the admin channel list',
});
exports.ChannelList = effect_1.Schema.Struct({
    channels: effect_1.Schema.Array(exports.Channel),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelList`,
});
const adminChannelOwner = {
    userId: (0, field_1.nonEmpty)('Owner user id'),
    appId: (0, field_1.nonEmpty)('Client application id'),
};
const optionalChannelName = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Display name',
});
exports.MobileChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    token: (0, field_1.nonEmpty)('Push token'),
    platform: effect_1.Schema.Literal('ios', 'android'),
    tokenType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('message', 'pass'), { exact: true }),
    deliveryMethod: effect_1.Schema.optionalWith(effect_1.Schema.Literal('fcm'), { exact: true }),
    permKey: (0, field_1.optionalString)('Apple APN permission key'),
    name: optionalChannelName,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelCreatePayload`,
});
exports.MobileChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.MobileChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.EmailChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    email: effect_1.Schema.propertySignature(email('Recipient email')).annotations({
        description: 'Recipient email',
    }),
    name: optionalChannelName,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelCreatePayload`,
});
exports.EmailChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.EmailChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.SmsChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    number: (0, field_1.nonEmpty)('Recipient phone number'),
    name: optionalChannelName,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelCreatePayload`,
});
exports.SmsChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.SmsChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.ChannelDeletePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelDeletePayload`,
    description: 'Admin delete only uses channelId; userId and appId are not required at runtime',
});
exports.ChannelUpsertResult = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Created or updated channel id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelUpsertResult`,
});
exports.Scope = effect_1.Schema.Literal('device', 'model', 'tenant', 'all').annotations({
    identifier: `${exports.NAMESPACE}.Scope`,
});
exports.TriggerType = effect_1.Schema.Literal('registry', 'connection', 'property', 'alarm', 'error', 'event').annotations({
    identifier: `${exports.NAMESPACE}.TriggerType`,
});
exports.TriggerEvent = effect_1.Schema.Literal('on_new_datapoint', 'on_value_change', 'on_value_compare', 'on_value_change_compare').annotations({
    identifier: `${exports.NAMESPACE}.TriggerEvent`,
    description: 'Required. When triggerType is event, alarm or error, runtime accepts only on_new_datapoint',
});
const ruleFields = {
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.Array(effect_1.Schema.String)).annotations({
        description: 'Notification channel ids',
    }),
    scope: effect_1.Schema.optionalWith(exports.Scope, { exact: true }).annotations({
        description: 'Defaults to device',
    }),
    tenantId: (0, field_1.optionalString)('Required by runtime when scope is tenant'),
    models: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Required only for model scope; forbidden for other scopes',
    }),
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Required for device scope; forbidden for model, tenant and all scopes',
    }),
    triggerType: effect_1.Schema.propertySignature(exports.TriggerType),
    triggerEvent: effect_1.Schema.propertySignature(exports.TriggerEvent),
    propertyName: (0, field_1.optionalString)('Required for property triggers'),
    valueComparisonOperator: effect_1.Schema.optionalWith(effect_1.Schema.Literal('==', '!=', '<', '>', '<=', '>='), {
        exact: true,
    }).annotations({
        description: 'Required when triggerEvent is on_value_compare',
    }),
    valueThreshold: effect_1.Schema.optionalWith(Json.Value, { exact: true }).annotations({
        description: 'Required when triggerEvent is on_value_compare; runtime does not constrain its type',
    }),
    occurrenceName: (0, field_1.optionalString)('Required for event, alarm and error triggers'),
    emailSubject: (0, field_1.optionalString)('Email subject template'),
    emailBody: (0, field_1.optionalString)('Email body template'),
    emailTemplateId: (0, field_1.optionalString)('Email template id'),
    pushTitle: (0, field_1.optionalString)('Mobile push title template'),
    pushBody: (0, field_1.optionalString)('Mobile push body template'),
    pushImageUrl: optionalUri('Mobile push image URL; runtime validates isURL()'),
    smsMessage: (0, field_1.optionalString)('SMS message template'),
    pushMetadata: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
    webhookMetadata: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
    minInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(60)), { exact: true }),
    gracePeriod: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()), { exact: true }),
    name: (0, field_1.optionalString)('Display name'),
};
exports.NotificationCreatePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    ...ruleFields,
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.Array(effect_1.Schema.String).pipe(effect_1.Schema.minItems(1))).annotations({
        description: 'At least one notification channel id',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationCreatePayload`,
});
exports.NotificationUpdatePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
    ...ruleFields,
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.Array(effect_1.Schema.String).pipe(effect_1.Schema.minItems(1))).annotations({
        description: 'At least one notification channel id',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationUpdatePayload`,
});
exports.NotificationDeletePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationDeletePayload`,
    description: 'After ruleId→notificationId aliasing, runtime validates only notificationId (not the full create/update rule schema). userId is still required by the admin wrapper.',
});
exports.Notification = effect_1.Schema.Struct({
    notificationId: (0, field_1.nonEmpty)('Notification id projected from stored id'),
    ruleId: (0, field_1.nonEmpty)('Rule id projected from stored id'),
    userId: (0, field_1.nonEmpty)('Owner user id'),
    version: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
    active: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    actionType: (0, field_1.optionalString)('Rule action type'),
    ...ruleFields,
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    models: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    propertyName: (0, field_1.optionalNullableString)('Trigger property name'),
    valueComparisonOperator: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Literal('==', '!=', '<', '>', '<=', '>=')), {
        exact: true,
    }),
    valueThreshold: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    occurrenceName: (0, field_1.optionalNullableString)('Event, alarm or error occurrence name'),
    emailSubject: (0, field_1.optionalNullableString)('Email subject template'),
    emailBody: (0, field_1.optionalNullableString)('Email body template'),
    emailTemplateId: (0, field_1.optionalNullableString)('Email template id'),
    pushTitle: (0, field_1.optionalNullableString)('Mobile push title template'),
    pushBody: (0, field_1.optionalNullableString)('Mobile push body template'),
    pushImageUrl: (0, field_1.optionalNullableString)('Mobile push image URL'),
    smsMessage: (0, field_1.optionalNullableString)('SMS message template'),
    pushMetadata: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }),
    webhookMetadata: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }),
    gracePeriod: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())), { exact: true }),
    minInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()), { exact: true }).annotations({
        description: 'Seconds between notifications. Stored as 0 when not set; delivery then falls back to 60',
    }),
    lastSentAt: optionalDateTime('ISO-8601 time of the last delivery attempt, set by logSent'),
    name: (0, field_1.optionalNullableString)('Display name'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Notification`,
    description: 'Admin notification rule with stored id projected to notificationId and ruleId',
});
exports.NotificationList = effect_1.Schema.Struct({
    notifications: effect_1.Schema.Array(exports.Notification),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationList`,
});
exports.HistoryItem = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('History record id'),
    ruleId: effect_1.Schema.String,
    userId: effect_1.Schema.String,
    deviceId: effect_1.Schema.String,
    channelId: effect_1.Schema.String,
    channelType: exports.ChannelType,
    value: effect_1.Schema.NullOr(Json.Value),
    result: effect_1.Schema.NullOr(Json.Value),
    sentAt: (0, field_1.dateTime)('Notification sent time'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
}).annotations({
    identifier: `${exports.NAMESPACE}.HistoryItem`,
});
exports.HistoryPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.HistoryItem),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(openapi_1.Response.ProviderMetadata, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.HistoryPage`,
});
//# sourceMappingURL=schema.js.map